module.exports = __webpack_public_path__ + "media/src/images/partners/land_der_ideen-b1357ab86f996704182afd0f7b9e4a06.jpg";